import { conditionAddress, normalizeCondition } from "../condition";
import { executionFlagsToOptions } from "./executionFlagsToOptions";
export const targetId = (permission) => "selector" in permission
    ? `${permission.targetAddress.toLowerCase()}.${permission.selector}`
    : `${permission.targetAddress.toLowerCase()}.*`; // * will be always be sorted before any selector 0x...
export const permissionId = (permission) => {
    const cid = "condition" in permission && permission.condition
        ? conditionAddress(normalizeCondition(permission.condition))
        : "";
    return `${targetId(permission)}:${executionFlagsToOptions(permission)}:${cid}`;
};
export const isPermissionAllowed = (permission) => {
    return !("selector" in permission) && !("signature" in permission);
};
export const isPermissionScoped = (permission) => {
    return "selector" in permission || "signature" in permission;
};
export const isPermissionWildcarded = (permission) => {
    return isPermissionScoped(permission) && !permission.condition;
};
export const isPermissionConditional = (permission) => {
    return isPermissionScoped(permission) && !!permission.condition;
};
